import { render, staticRenderFns } from "./RegistrationsList.vue?vue&type=template&id=1ad998da&scoped=true&"
import script from "./RegistrationsList.vue?vue&type=script&setup=true&lang=ts&"
export * from "./RegistrationsList.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./RegistrationsList.vue?vue&type=style&index=0&id=1ad998da&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad998da",
  null
  
)

export default component.exports